import Loading from 'components/Loading';
import MainButton from 'components/MainButton';
import {
  SessionActions,
  SessionBottom,
  SessionHeadline,
  SessionMainText,
  SessionTop
} from 'domain/assistant/session-elements';
import StepContainer, { scrollSidebar } from 'domain/assistant/StepContainer';
import getIntl from 'i18n/locales';
import { inject, observer } from 'mobx-react';
import { ApplicationStoreType } from 'models/ApplicationStore';
import { AssistantStoreType } from 'models/AssistantStore';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getStepInfo } from 'utils/constants/assistant-steps';
import { ROUTE_ASSISTANT, ROUTE_LAB } from 'utils/constants/routes';
import { HistoryProps } from 'utils/history';

interface HypothesisDoneScreenProps {
  applicationStore: ApplicationStoreType;
  assistantStore: AssistantStoreType;
}

@inject('applicationStore', 'assistantStore')
@observer
class HypothesisDoneScreen extends React.Component<
  HypothesisDoneScreenProps & HistoryProps
> {
  componentDidMount() {
    scrollSidebar('hypothesis');
  }

  private async publish() {
    const { assistantStore, history } = this.props;

    if (!assistantStore.currentId) {
      return;
    }

    try {
      const session = await assistantStore.publishAssistantSession(
        assistantStore.currentId
      );

      if (session?.hypothesis_id && session.project?.organization_id) {
        history.push(
          ROUTE_LAB +
            '/' +
            session.project.organization_id +
            '/' +
            session.project.id +
            '/hypotheses/' +
            session.hypothesis_id
        );
      } else {
        history.push(ROUTE_ASSISTANT);
      }
    } catch (error: any) {
      this.props.applicationStore.setFlashMessage(
        getIntl().formatMessage({ id: 'assistant publish error' }),
        'error'
      );
    }
  }

  private saveDraft() {
    this.props.history.push(ROUTE_ASSISTANT);
  }

  render() {
    const { assistantStore } = this.props;
    const { currentItem, currentAssistantType } = assistantStore;

    const stepInfo = getStepInfo('step4_3', currentAssistantType);

    return (
      <StepContainer
        progress={stepInfo?.percent}
        sidebarHeadline={stepInfo?.header}
        showHeader="hypothesis"
        location={this.props.location}
      >
        {assistantStore.isItemSaving && <Loading />}

        <SessionTop>
          <SessionHeadline step={stepInfo?.header}>
            <FormattedMessage id="assistant hypothesis publish header" />
          </SessionHeadline>

          <SessionMainText>
            <FormattedMessage
              id="assistant hypothesis publish"
              values={{
                projectName: currentItem?.project?.name || '',
                break: <br />
              }}
            />
          </SessionMainText>
        </SessionTop>

        <SessionBottom>
          <SessionActions>
            <MainButton
              onClick={() => this.publish()}
              disabled={currentItem?.published}
            >
              <FormattedMessage id="Publish results" />
            </MainButton>

            <br />

            <MainButton onClick={() => this.saveDraft()}>
              <FormattedMessage id="Save as draft only" />
            </MainButton>
          </SessionActions>
        </SessionBottom>
      </StepContainer>
    );
  }
}

export default HypothesisDoneScreen;
